import { createFileRoute } from "@tanstack/react-router";
import NebraskaBlueInsurance, { config } from "@/pages/NebraskaBlueInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/nebraska-blue-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Nebraska Blue TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Nebraska Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Nebraska Blue TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Nebraska Blue Cross Blue Shield coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/nebraska-blue-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/nebraska-blue-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <NebraskaBlueInsurance />;
}
